import { render, staticRenderFns } from "./AttachedFilesSection.vue?vue&type=template&id=7c729678&scoped=true"
import script from "./AttachedFilesSection.vue?vue&type=script&lang=js"
export * from "./AttachedFilesSection.vue?vue&type=script&lang=js"
import style0 from "./AttachedFilesSection.vue?vue&type=style&index=0&id=7c729678&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c729678",
  null
  
)

export default component.exports